import { useEffect, useState } from "react";
import { createFileRoute } from "@tanstack/react-router";
import { Spinner } from "@heroui/react";
import { useDocumentTitle } from "@/hooks/useDocumentTitle";

const TERMS_PAGES = {
  "user-terms": "用户服务条款",
  "third-party": "第三方服务和隐私条款",
  "privacy": "隐私政策",
} as const;

type TermsPageKey = keyof typeof TERMS_PAGES;

function isTermsPage(page: string): page is TermsPageKey {
  return Object.prototype.hasOwnProperty.call(TERMS_PAGES, page);
}

export const Route = createFileRoute("/terms/$page")({
  component: TermsPage,
});

function TermsPage() {
  const { page } = Route.useParams();
  const known = isTermsPage(page);
  const title = known ? TERMS_PAGES[page] : "页面不存在";
  const [loaded, setLoaded] = useState(false);

  useDocumentTitle(known ? `${title} - 兽聚汇` : "兽聚汇");

  useEffect(() => {
    setLoaded(false);
  }, [page]);

  if (!known) {
    return (
      <div className="flex h-screen items-center justify-center text-sm text-gray-500">
        页面不存在
      </div>
    );
  }

  return (
    <div className="relative h-screen w-full p-6" style={{ height: "100dvh" }}>
      {!loaded && (
        <div className="absolute inset-0 flex items-center justify-center">
          <Spinner size="sm" />
        </div>
      )}
      <iframe
        src={`https://www.furries.cn/terms/${page}`}
        title={title}
        className="h-full w-full border-0 scrollbar-none"
        onLoad={() => setLoaded(true)}
      />
    </div>
  );
}
